export default "__VITE_ASSET__BLBJakcH__"